<template>
  <div>
    <Select v-model="row.type"
            @on-change="changeType"
            class="type-select"
            :placeholder="row.type ? row.type : 'no data'"
    >
      <Option v-for="(type, idx) in types"
              :key="idx"
              :value="type"
              :label="type"
      >
        <span>{{ type }}</span>
      </Option>
    </Select>
  </div>
</template>

<script>
export default {
  name: "TransactionType",
  props: {
    row: {
      type: Object,
    }
  },
  data() {
    return {
      types: ["M", "RC", "SMSF", "C"]
    }
  },
  methods: {
    changeType() {
      const params = {};

      params["type"] = this.row.type;
      params["id"] = this.row.id;

      this.$store.dispatch("changeType", params)
      
    }
  },
 
}
</script>

<style scoped>

</style>